import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const JenisDokumen = ({id}) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [jenisDokumen, setJenisDokumen] = useState('')

    useEffect(() => {
        const getJenisDokumen = async () => {
            const response = await masterService.getJenisDokById(id)
            setJenisDokumen(response.data.jenisDok)
        }
        getJenisDokumen()
    }, [masterService, id])

    return (
        <>
            {jenisDokumen}
        </>
    )
}

export default JenisDokumen